import { orderBy } from 'lodash'
import {
  ActivityId,
  Dictionary,
  WebchatLog,
  WebchatMessage,
  WEBCHAT_TIME_PROP
} from '@feedyou/utils'

export const BEFORE_FIRST_MESSAGE = Symbol.for('BEFORE FIRST MESSAGE')

export function groupLogEntriesByPreviousMessage(
  messagesFromOldest: WebchatMessage[],
  visibleLogEntriesFromOldest: WebchatLog[]
): Dictionary<ActivityId, WebchatLog[]> {
  // re-sorting an already sorted array does not cost almost anything,
  // so might as well do it to prevent future bugs
  const messagesResorted = orderBy(messagesFromOldest, WEBCHAT_TIME_PROP, 'asc')
  const visibleLogEntriesResorted = orderBy(visibleLogEntriesFromOldest, WEBCHAT_TIME_PROP, 'asc')

  const firstMessageTimeBoundary = messagesResorted[0]?.microsecondTimestamp ?? Infinity
  const logEntriesBeforeFirstMessage = visibleLogEntriesResorted.filter(
    log => log.microsecondTimestamp < firstMessageTimeBoundary
  )

  return messagesResorted.reduce(
    (output, message, index, messages) => {
      const currentMessageTimestamp = message.microsecondTimestamp
      const nextMessageTimestamp = messages[index + 1]?.microsecondTimestamp ?? Infinity

      output[message.activityId] = visibleLogEntriesResorted.filter(log => {
        return (
          nextMessageTimestamp > log.microsecondTimestamp &&
          currentMessageTimestamp <= log.microsecondTimestamp
        )
      })

      return output
    },
    { [BEFORE_FIRST_MESSAGE]: logEntriesBeforeFirstMessage } as Dictionary<ActivityId, WebchatLog[]>
  )
}
